<template>
    <video ref="videoPlayer" class="video-js" id="live-video"></video>
</template>

<script>
import $ from "jquery";
import videojs from "video.js";

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.pauseRadioPlayer();
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log("onPlayerReady", this);
      }
    );
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    pauseRadioPlayer() {
      let audio = $("audio")[0];
      if (!audio.paused) {
        audio.pause();
        $("#radioplayer__data__button-container button").removeClass("icon-pause");
        $("#radioplayer__data__button-container button").addClass("icon-play");
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../node_modules/video.js/dist/video-js.css';

#live-video {
  width: 100vw;
  height: calc(56.25vw);
  max-width: 768px;
  max-height: 432px;
  position: relative;

  .vjs-big-play-button {
    top: calc(50% - 25px) !important;
    left: calc(50% - 45px) !important;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 599px)  {
    #live-video {
      margin: 0px -16px 16px !important;
    }
}

@media only screen and (min-device-width: 600px) and (max-device-width: 1199px)  {
    #live-video {
      margin: 0px 0px 16px !important;
    }
}
</style>